import { createContext, use } from 'react'

import { ExistingLoanOfferContext } from '../types'

export const LoanOfferContext = createContext({} as ExistingLoanOfferContext)

export const useExistingLoanOfferContext = () => {
  const context = use(LoanOfferContext)
  if (context === undefined) {
    throw new Error('useLoanOfferContext must be used within a LoanOfferContext')
  }
  return context
}
